import React, { lazy } from 'react';
import { useInjectReducer } from 'utils/redux-injectors';
import { invoiceApi } from './slice';

const Invoices = lazy(() => import('./index'));

export default function InvoicesLoadable() {
  useInjectReducer({ key: invoiceApi.reducerPath, reducer: invoiceApi.reducer });
  return <Invoices />;
}
